// extracted by mini-css-extract-plugin
module.exports = {"level_0":"AddComment_level_0__3u89h","level_1":"AddComment_level_1__B4Ie2"};